<template>
  <div class="container">
    <LoadedComponent :loading="loading" />

    <div class="row" v-if="!loading">
      <div class="col-lg-9">
        <div class="row" v-if="publishAdv">
          <div class="col-lg-12">
            <div class="pr-5">
              <AdvComponent :advertisings="advertisings" />
            </div>
          </div>
        </div>

        <div class="row" v-if="clinicalCases.length > 0">
          <div class="col-lg-12 pt-4 pr-5">
            <div class="card p-2">
              <h4 class="text-center pt-2">Casi Clinici</h4>
              <div class="card-body">
                <SwiperComponents :elements="clinicalCases" category="1" />
              </div>
            </div>
          </div>
        </div>

        <div class="row" style="max-height: 600px" v-if="meeting.length > 0">
          <div class="col-lg-12 pt-4 pr-5">
            <div class="card p-2">
              <h4 class="text-center pt-2">Meeting</h4>
              <div class="card-body">
                <SwiperComponents :elements="meeting" category="3" />
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="library.length > 0">
          <div class="col-lg-12 pt-4 pr-5">
            <div class="card p-2">
              <h4 class="text-center pt-2">Biblioteca</h4>
              <SwiperComponents :elements="library" category="2" />
            </div>
          </div>
        </div>

        <div class="row" v-if="presentation.length > 0">
          <div class="col-lg-12 pt-4 pr-5 pb-4">
            <div class="card p-2">
              <h4 class="text-center pt-2">Presentazioni</h4>
              <SwiperComponents :elements="presentation" category="4" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="row">
          <aside class="col-lg-12 pt-4">
            <div class="card">
              <div class="p-4">
                <div class="float-left">
                  <h4 class="card-title">News</h4>
                </div>
                <div class="float-right">
                  <a
                    href="#newsletter-create-modal"
                    class="btn btn-primary btn-circle"
                    data-toggle="modal"
                    style="font-size: 15px"
                    v-if="create_newsletter"
                    ><i class="las la-newspaper"></i
                  ></a>
                </div>
              </div>
              <div style="overflow-y: auto; height: 500px">
                <div
                  v-for="(newsletter, index) in newsletters"
                  :key="index"
                  class="mb-2"
                >
                  <div class="p-4">
                    <div v-html="newsletter.description"></div>
                    <div class="w-100" v-if="newsletter.deleted">
                      <div class="float-right">
                        <button
                          type="button"
                          class="btn btn-danger btn-circle"
                          data-toggle="modal"
                          data-target="#confirm-delete"
                          v-if="newsletter.deleted"
                          @click="showConfirmationDelete(newsletter.id)"
                        >
                          <i class="las la-trash-alt"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" role="dialog" id="confirm-delete">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Conferma eliminazione</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal-delete-news"
            >
              <span aria-hidden="true"><i class="icon-close"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container">
              <p>Sei sicuro di voler eliminare l'elemento?</p>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              Annulla
            </button>
            <button
              type="button"
              class="btn btn-outline-danger"
              @click="deleteElement"
            >
              Elimina
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
      id="newsletter-create-modal"
    >
      <div class="modal-dialog modal-xl" role="document" style="max-width: 90%">
        <div class="modal-content">
          <div class="modal-header">
            <div class="w-100">
              <h5 class="modal-title text-center">Nuova newsletter</h5>
            </div>
          </div>
          <div class="modal-body p-4">
            <form @submit.prevent="newsletterstore">
              <div class="form-group">
                <QuillEditor
                  v-model:content="newsletterform.description"
                  contentType="html"
                  theme="snow"
                  :options="options"
                  style="height: 300px"
                />
              </div>

              <div class="alert alert-danger" v-if="errors.description">
                {{ errors.description[0] }}
              </div>
              <div class="form-footer">
                <button
                  type="submit"
                  class="btn btn-outline-primary-2 btn-order btn-block"
                >
                  Pubblica la newsletter
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- End .modal -->
  </div>
</template>

<script>
import httpauth from "@/services/httpauth.js";
import SwiperComponents from "@/components/SwiperComponents.vue";

import httpservices from "@/services/httpservices";

import LoadedComponent from "@/components/LoadedComponent.vue";
import { useAuth } from "@/stores/auth.js";
import AdvComponent from "@/components/AdvComponent.vue";
import { QuillEditor } from "@vueup/vue-quill";
import { useToast } from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import $ from "jquery";
window.jQuery = $;
window.$ = $;
export default {
  name: "HomePage",
  components: {
    SwiperComponents,
    LoadedComponent,
    AdvComponent,
    QuillEditor,
  },
  props: {},
  data() {
    return {
      clinicalCases: [],
      attributes: [],
      meeting: [],
      library: [],
      presentation: [],
      newsletters: [],
      forum: [],
      loading: true,
      publishAdv: false,
      advertisings: [],
      errors: {},
      newsletterform: {
        description: "",
      },
      create_newsletter: false,
      newsletterid: 0,

      options: {
        debug: "info",
        placeholder: "Scrivi il messaggio da comuinicare a tutti",
        readOnly: false,
        theme: "snow",
        autosize: { minRows: 3, maxRows: 10 },
      },
    };
  },
  mounted() {
    if (this.publishAdv) {
      this.adv();
    }
    this.getDashboard();
  },
  created() {
    httpservices
      .checkPermission(0, "newsletter", "create_newsletter")
      .then((response) => {
        this.create_newsletter = response.data.permission;
      });
  },
  methods: {
    async getDashboard() {
      await httpauth
        .get("/dashboard")
        .then((response) => {
          var data = response.data;
          this.clinicalCases = data.clinicalCases;
          this.meeting = data.meetings;
          this.library = data.libraries;
          this.presentation = data.presetations;
          this.newsletters = data.newsletters;
          this.loading = false;
          // Gestisci l'array di oggetti come desiderato
        })
        .catch((error) => {
          console.log(error);
          const auth = useAuth();
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          ) {
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async adv() {
      await httpauth
        .get("/advertising")
        .then((response) => {
          this.advertisings = response.data.data.content;
          console.log(this.advertisings);
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          ) {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    dayClicked(day) {
      console.log(day);
    },
    async newsletterstore() {
      await httpauth
        .post("/newsletter/store", this.newsletterform)
        .then((response) => {
          console.log("entro");
          const $toast = useToast();
          $toast.open({
            message: response.data.message,
            type: "success",
            position: "top-right",
            // all of other options may go here
          });
          $("#newsletter-create-modal").modal("hide");

          this.newsletterform.description = "";

          this.shownewsletter();
        })
        .catch((error) => {
          if (error.response) {
            this.errors = error.response.data.errors;
          }
        });
    },
    showConfirmationDelete(id) {
      this.newsletterid = id;
    },
    async shownewsletter() {
      await httpauth
        .get("/newsletter")
        .then((response) => {
          this.newsletters = [];
          this.newsletters = response.data.data;
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
        });
    },
    async deleteElement() {
      if (this.newsletterid != 0) {
        await httpauth
          .get("/newsletter/delete/" + this.newsletterid, [
            {
              params: { id: this.newsletterid }, // Passa l'ID come oggetto nel campo 'data'
            },
          ])
          .then((response) => {
            const $toast = useToast();
            $toast.open({
              message: response.data.message,
              type: "success",
              position: "top-right",
              // all of other options may go here
            });
            $("#newsletter-create-modal").modal("hide");

            this.shownewsletter();
          })
          .catch((error) => {
            this.errors = error.response.data.errors;
          });
      } else {
        this.errors.message = "Non è stato inserito nessuna newsletter";
      }
    },
  },
};
</script>
<style scoped>
.btn-link:hover,
.btn-link:focus,
.btn-link .btn-link-dark:hover,
.btn-link .btn-link-dark:focus {
  color: #177fd5;
  border-color: #177fd5;
}
.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem; /* 14px */
  line-height: 1.5;
  border-radius: 0.2rem;
  min-width: 0px;
}
.btn-circle.btn-xl {
  width: 70px;
  height: 70px;
  padding: 10px 16px;
  border-radius: 35px;
  font-size: 24px;
  line-height: 1.33;
}

.btn-circle {
  width: 30px;
  height: 30px;
  padding: 6px 0px;
  border-radius: 15px;
  text-align: center;
  font-size: 12px;
  line-height: 1.42857;
}
.btn {
  min-width: 0px;
}
</style>